export default __webpack_public_path__ + "static/media/pii2.a3afb7a0.svg";